var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"timeline","fluid":"","tag":"section"}},[_c('hello-world-component',{attrs:{"role":_vm.User}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }